exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text[data-v-4330493a]{margin-top:16px;color:#454545;font-size:14px;line-height:25px;padding-right:16px}.text span[data-v-4330493a]{margin-top:8px;display:block;white-space:nowrap}@media screen and (max-width:816px){.text span[data-v-4330493a]{font-size:12px}}.result[data-v-4330493a]{display:flex}.container[data-v-4330493a]{width:400px}.btn[data-v-4330493a]{margin:0 8px}.btn-group[data-v-4330493a]{margin-top:24px;justify-content:space-around}.three-buttons .btn[data-v-4330493a]{margin:0 4px;padding:16px 6px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4330493a","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/assistance_steps/Result.vue
// module id = 200
// module chunks = 0